import React, {useState, useContext, useEffect} from 'react';
import Cookies from 'js-cookie';
import './Banner.less';
import {ButtonPrimary, ButtonIcon} from '@homeaway/react-buttons';
import {TrackingContext} from '@homeaway/react-event-tracking';
import StarRating from '@homeaway/react-star-rating';
import {CLOSE__12} from '@homeaway/svg-defs';
import * as BannerDefaults from '../banner-defaults';
import * as BannerHelpers from '../utils/bannerHelpers';
import {createCookie, cookieExists, APP_BANNER_COOKIE_NAME} from '../utils/cookies';
import {triggerEdapEvent} from '../utils/triggerEdapEvent';

export const Banner = ({buttonLabel,
    ctaLink,
    description,
    rating,
    showBanner,
    stars,
    travelerApp,
    title,
    useCanonicalPath}) => {
    const context = useContext(TrackingContext);
    const brandName = BannerHelpers.getBrandName(travelerApp);
    showBanner = showBanner || false;
    buttonLabel = BannerHelpers.getButtonLabel(buttonLabel);
    description = description || BannerDefaults.DESCRIPTION;
    stars = parseFloat(stars) || BannerDefaults.STARS;
    rating = rating || BannerDefaults.RATING;
    title = title || BannerDefaults.TITLE.replace('brand', brandName);
    const site = BannerHelpers.getSite(brandName);
    const imgUrl = BannerHelpers.getImgUrl(site);

    const [showBannerState, setShowBannerState] = useState(null);
    const [bannerSelected, setBannerSelected] = useState(null);
    const [bannerPresented, setBannerPresented] = useState(null);
    const [bannerDismissed, setBannerDismissed] = useState(null);
    const [adjustHeight, setAdjustHeight] = useState(false);
    const [adjustButton, setAdjustButton] = useState(false);

    function createLink() {
        return BannerHelpers.getDownloadLink(ctaLink, brandName, Cookies.get('hav'), Cookies.get('xdid'));
    }

    const [link, setLink] = useState(createLink());
    const [path, setPath] = typeof window !== 'undefined' ? useState(window.location) : '';

    useEffect(() => {
        if (useCanonicalPath && typeof window !== 'undefined') {
            setPath(window.location);
        }
    }, [path]);


    useEffect(() => {
        if (cookieExists(APP_BANNER_COOKIE_NAME) || bannerSelected || bannerDismissed) {
            setShowBannerState(false);
        } else {
            setShowBannerState(showBanner);
        }
    });

    useEffect(() => {
        if (!bannerPresented && !cookieExists(APP_BANNER_COOKIE_NAME) && showBannerState) {
            triggerEdapEvent(context, 'presented');
            setBannerPresented(true);
        }
    });

    useEffect(() => {
        if (document.getElementsByClassName('app-banner__title')[0] && document.getElementsByClassName('app-banner__title')[0].offsetHeight > 22) {
            setAdjustHeight(true);
        } else {
            setAdjustHeight(false);
        }
        if (document.getElementsByClassName('app-banner__button')[0] && document.getElementsByClassName('app-banner__button')[0].textContent.length > 13) {
            setAdjustButton(true);
        } else {
            setAdjustButton(false);
        }
    });

    function handleCloseButtonClick() {
        setBannerDismissed(true);
        triggerEdapEvent(context, 'dismissed');
        createCookie();
    }

    function handleDownloadButtonClick() {
        setBannerSelected(true);
        triggerEdapEvent(context, 'selected');
        if (useCanonicalPath) {
            setLink(`${link}&$canonical_url=${path}`);
        }
        createCookie();
    }

    return (
        <div className="app-banner">
            {showBannerState &&
                <div className={`app-banner__content ${adjustHeight ? ' app-banner__adjust-height' : ''}`}>
                    <div className="app-banner__right">
                        <ButtonPrimary
                            arial-label="App Download or App Open Button"
                            className={`app-banner__button ${adjustButton ? ' app-banner__adjust-button' : ''}`}
                            data-testid="download-button"
                            href={link}
                            label={buttonLabel}
                            onClick={handleDownloadButtonClick}
                            type="button"
                            size="xs"
                        />
                    </div>
                    <div className="app-banner__left">
                        <div className="app-banner__close">
                            <ButtonIcon size="xs" noBorder role="button"
                                aria-label="Close banner" label="Close Button" svgMarkup={CLOSE__12}
                                onClick={handleCloseButtonClick}
                                data-testid="close-button"
                            />
                        </div>
                        <div className="app-banner__icon">
                            <img src={imgUrl} alt={`${brandName} Logo`} />
                        </div>
                        <div className="app-banner__details">
                            <div className="app-banner__title">
                                {title}
                            </div>
                            <div className="app-banner__description">
                                {description}
                            </div>
                            <div className="app-banner__stars" >
                                <StarRating rating={stars} />
                            </div>
                            <div className="app-banner__reviews">
                                {rating}
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};
